import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
    const [settings, setSettings] = useState(null);

    useEffect(() => {
        const cacheKey = 'settings';
        const cacheTimestampKey = 'settingsTimestamp';
        const cacheExpiryTime = 30 * 60 * 1000; // 30 minutes in milliseconds

        // Check if settings are cached and not expired
        const cachedSettings = localStorage.getItem(cacheKey);
        const cachedTimestamp = localStorage.getItem(cacheTimestampKey);

        const isCacheValid = cachedSettings && cachedTimestamp && (Date.now() - cachedTimestamp < cacheExpiryTime);

        if (isCacheValid) {
            setSettings(JSON.parse(cachedSettings));
        } else {
            // Fetch settings from API if no valid cache
            const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
            const Url = process.env.REACT_APP_API_SETTING;
            axios.get(`${apiBaseUrl}${Url}`)
                .then(res => {
                    const newSettings = res.data;
                    setSettings(newSettings);

                    // Save new settings to localStorage
                    localStorage.setItem(cacheKey, JSON.stringify(newSettings));
                    localStorage.setItem(cacheTimestampKey, Date.now().toString());
                })
                .catch(err => console.error('Error fetching settings', err));
        }
    }, []);

    return (
        <SettingsContext.Provider value={settings}>
            {children}
        </SettingsContext.Provider>
    );
};

export const useSettings = () => useContext(SettingsContext);
